import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css'; // 반드시 추가

const menus = {
  about: [
    { name: '회사개요', path: '' },
    { name: '회사연혁', path: 'history' },
    { name: '조 직 도', path: 'organization' },
    { name: '기업이념', path: 'philosophy' },
    { name: '사업분야', path: 'business' },
    { name: '보유기술', path: 'technology' },
    { name: '장비보유현황', path: 'equipment' }
  ],
  services: [
    { name: '동파방지열선제어', path: '' },
    { name: '스마트팜환경제어', path: 'smartfarm' },
    { name: 'PSI5롬라이터', path: 'psi5interface' },
    { name: '포토부스 IO박스', path: 'photoboothIO' },
    { name: '하네스검사기', path: 'hanesstester'},
    { name: '모터신뢰성검사기', path: 'motortester'}
  ]
};

function Sidebar({ section }) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="sidebar">
      <div className="sidebar-menu">
        {menus[section].map((item, idx) => {
          const fullPath = `/${section}/${item.path}`;
          const isActive = currentPath === fullPath || (item.path === '' && currentPath === `/${section}`);

          return (
            <div key={idx} className="sidebar-item">
              <Link
                to={fullPath}
                className={`sidebar-link ${isActive ? 'active' : ''}`}
              >
                {item.name}
              </Link>
            </div>
          );
        })}
      </div>

      <div className="sidebar-tail">
        <div>(주)타마</div>
        <div>서울특별시 금천구<br />가산디지털1로 75-15<br />(하우스디와이즈타워, 926-927)</div>
        <div>Tel. 02-448-2871</div>
        <div>Fax. 02-448-2872</div>
        <div>
          <a href="mailto:tama@ta-ma.net">tama@ta-ma.net</a>
        </div>

        {/* 🔽 추가 */}
        <div style={{ marginTop: "10px" }}>
          <Link to="/privacy" className="privacy-link">
            개인정보처리방침
          </Link>
        </div>

        <div className="copyright">
          © {new Date().getFullYear()} TAMA Co., Ltd. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
